module.exports = __webpack_public_path__ + "static/media/profile_1.9456b988.jpg";